import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import useScribbleTooltip from "../../../../hooks/answeringQuestions/useScribbleTooltip";

const Scribbler = ( props ) => {

  const dispatch = useDispatch();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  const { hideScribbleTooltip } = useScribbleTooltip();

  const scribble = () => {
    setQuestionView( { isScribble : true } );
    hideScribbleTooltip();
  };

  return cloneElement( props.children || <Fragment />, {
    onScribble : scribble
  } );

};

export default Scribbler;
